// CommunicatorPlugin/common/schemas/collections/telephonyExtensions.js
import { z } from "zod";

const TelephonyExtensionSchema = z.object({
    _id: z.string().optional().describe("MongoDB ObjectId as a string."),
    
    subscriptionId: z.string().optional().describe("The tenant this extension belongs to."),
    serviceCode: z.string().optional().describe("The service code of the subscription, used for the full name prefix."),
    
    extensionNumber: z.string().regex(/^\d{3,7}$/, "Must be 3-7 digits").describe("The short extension number (e.g., 1001)."),
    fullName: z.string().optional().describe("The full user ID for FreeSWITCH (e.g., ACME-1001). Auto-generated."),
    password: z.string().describe("The SIP password for the extension."),
    
    outboundCallerIdNumber: z.string().optional().nullable().describe("The DID to use for outbound calls from this extension."),
    
    assignedToType: z.enum(["agent", "user", "unassigned"]).default("unassigned"),
    assignedToId: z.string().optional().nullable().describe("The contactId of the agent or appUserId of the user."),
    
    isRemote: z.boolean().default(false).describe("True if this extension is assigned to an entity in a remote application."),
    apiKeyId: z.string().optional().nullable().describe("The _id of the apiKey record for the remote application."),
    agentContext: z.record(z.any()).optional().nullable().describe("Context for the remote agent (e.g., { agentId, agentName })."),

    metadata: z.record(z.any()).optional().default({}).describe("Flexible key-value store for additional data."),

    createdAt: z.coerce.date().optional(),
    updatedAt: z.coerce.date().optional(),
});

export default TelephonyExtensionSchema;